import axios from "../../../../api/axios";

import { WebSubscriptionTypePlan } from "../../types/plans";

type GetWebSubscriptionPlansResponse = {
  data: WebSubscriptionTypePlan[];
  message: string;
};

export const getWebSubscriptionPlans = async (): Promise<WebSubscriptionTypePlan[]> => {
  const response = await axios.get<GetWebSubscriptionPlansResponse>("subscription-types/web");
  return response.data.data;
};
